// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateWorkbookMutationVariables = Types.Exact<{
  workbookId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  description?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  parameterSetTypes?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
  parameterRefAliases?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
}>;

export type UpdateWorkbookMutation = {
  __typename?: "Mutation";
  updateWorkbook: {
    __typename?: "UpdateWorkbookPayload";
    workbookId?: string | null;
  };
};

export const UpdateWorkbookDocument = gql`
  mutation UpdateWorkbook(
    $workbookId: ID!
    $name: String
    $description: String
    $parameterSetTypes: [String!]
    $parameterRefAliases: [String!]
  ) {
    updateWorkbook(
      workbookId: $workbookId
      name: $name
      description: $description
      parameterSetTypes: $parameterSetTypes
      parameterRefAliases: $parameterRefAliases
    ) {
      workbookId
    }
  }
`;
export type UpdateWorkbookMutationFn = Apollo.MutationFunction<
  UpdateWorkbookMutation,
  UpdateWorkbookMutationVariables
>;

/**
 * __useUpdateWorkbookMutation__
 *
 * To run a mutation, you first call `useUpdateWorkbookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkbookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkbookMutation, { data, loading, error }] = useUpdateWorkbookMutation({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      parameterSetTypes: // value for 'parameterSetTypes'
 *      parameterRefAliases: // value for 'parameterRefAliases'
 *   },
 * });
 */
export function useUpdateWorkbookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkbookMutation,
    UpdateWorkbookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkbookMutation,
    UpdateWorkbookMutationVariables
  >(UpdateWorkbookDocument, options);
}
export type UpdateWorkbookMutationHookResult = ReturnType<
  typeof useUpdateWorkbookMutation
>;
export type UpdateWorkbookMutationResult =
  Apollo.MutationResult<UpdateWorkbookMutation>;
export type UpdateWorkbookMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkbookMutation,
  UpdateWorkbookMutationVariables
>;
